import { render, staticRenderFns } from "./ContentItemStatusView.vue?vue&type=template&id=240e2ff6&"
import script from "./ContentItemStatusView.vue?vue&type=script&lang=ts&"
export * from "./ContentItemStatusView.vue?vue&type=script&lang=ts&"
import style0 from "./ContentItemStatusView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QTooltip});
